module.exports = __webpack_public_path__ + "static/media/video_back_altern.0595c44e.jpg";